(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mcx-product-gallery"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {

  const galleries = document.querySelectorAll('.mcx-gallery');

  galleries.forEach(gallery => {

    const images = gallery.querySelectorAll('.mcx-gallery__image');
    const thumbs = gallery.querySelectorAll('.mcx-gallery__thumb');

    thumbs.forEach(thumb => {
      thumb.addEventListener('click', () => {

        const index = thumb.dataset.index;

        images.forEach(img => img.classList.remove('is-active'));
        thumbs.forEach(t => t.classList.remove('is-active'));

        gallery.querySelector(`.mcx-gallery__image[data-index="${index}"]`).classList.add('is-active');
        thumb.classList.add('is-active');

      });
    });

  });

});

  } catch(e) { console.error(e); }
})();
})();
